export const APP_URL = "https://ub.viyume.com";
export const API_URL = "https://web-api.viyume.com/mail/send-mail-ub";
export const RECAPTCHA_KEY = "6LfhtpYrAAAAAOZCO3Lt9l9ZXkXnf-cnyF9oIdTJ";

export const GOOGLE_PLAY_URL =
    "https://play.google.com/store/apps/details?id=com.viyume.uboards";
export const APP_STORE_URL =
    "https://apps.apple.com/vn/app/uboards/id6762424922?l=vi";
export const GOOGLE_PLAY_QR =
    "https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.viyume.uboards";
export const APP_STORE_QR =
    "https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=https%3A%2F%2Fapps.apple.com%2Fvn%2Fapp%2Fuboards%2Fid6762424922%3Fl%3Dvi";